<template>
  <transition name="fade" mode="out-in" tag="div">
    <div class="multiselect-wrapper">

      <multiselect id="ajax" track-by="code" :placeholder="placeholder" open-direction="bottom"
                   :disabled="disabled"
                   :options="options" :noOptions="noOptions" :selectLabel="selectLabel" :show-labels="false" :searchable="true"
                   :loading="isLoading" :internal-search="false" :clear-on-select="true" :close-on-select="true"
                   :options-limit="300" :limit="5" :limit-text="limitText" :max-height="600" :hide-selected="true"
                   @search-change="asyncFind" @select="click" @close="searchClosed">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div class="option__title">{{ props.option.simNumber }}</div>
          </div>
        </template>
        <span slot="noResult">{{ noResult }}</span>
        <span slot="noOptions">{{ noOptions }}</span>
      </multiselect>

    </div>
  </transition>
</template>

<script lang="ts">
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import axios from 'axios';

@Component({
  components: {
    Multiselect,
  },
})

export default class SimNumberSearch extends Vue {
  @Prop() public partnerCode!: string;
  @Prop() public customerId!: string;
  @Prop() public searchType!: number;
  @Prop() public searchProvider!: string;
  @Prop() public value!: string;
  @Prop() public disabled?: boolean;
  public minSearchLength = 4;
  public isLoading = false;
  public options: any = [];
  public timer: number|undefined = undefined;
  public currentNumber: any = '';
  public defaultPlaceholder: string = 'Zoek simnummerkaart';
  public placeholder: any = 'Zoek simnummerkaart';
  public selected: boolean = false;

  @Watch('value')
  valueChanged() {
    if (this.value === '') {
      this.selected = false;
      this.setPlaceholder();
      this.initValue();
    }
  }

  get selectLabel() {
    return 'Druk op enter om te kiezen';
  }

  get noResult() {
    return 'Geen resultaten gevonden.';
  }

  get noOptions() {
    return 'Voer minimaal drie cijfers in.';
  }

  public created() {
    this.setPlaceholder();
    this.initValue();
  }

  public setPlaceholder() {
    if (this.selected) {
      this.placeholder = this.currentNumber;
    } else {
      this.placeholder = this.defaultPlaceholder;
    }

    this.selected = false;
  }

  public initValue() {
    if (this.value) {
      this.placeholder = this.value;
    }
  }

  public limitText(count: number) {
    return `en ${count} andere resultaten`;
  }

  public click(value: any) {
    this.sendSimNumberSelectedEvent(value, true);
  }

  public sendSimNumberSelectedEvent(value: any, disableTmlField: boolean) {
    const data: any = [];

    data.searchType = this.searchType;
    data.searchProvider = this.searchProvider;
    data.simNumber = value.simNumber ? value.simNumber : value;
    data.tmlNumber = value.tmlNumber ? value.tmlNumber : null;
    data.disableTmlField = disableTmlField;

    this.currentNumber = value.simNumber ? value.simNumber : value;
    this.selected = true;

    this.$emit('simNumberSelected', data);
  }

  public searchClosed() {
    this.options = [];
    this.setPlaceholder();
  }

  public asyncFind(query: string) {
    this.options = [];

    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (query.search(/\+/g) !== -1) {
      query = query.replace(/\+/g, '');
    }

    if (query.length >= this.minSearchLength) {
      const url = '/-/trade/api/aloha.simcardsearch';

      const requestData = {
        type: this.searchType,
        provider: this.searchProvider,
        partnerCode: this.partnerCode,
        customerId: this.customerId,
        contains: query,
      };

      this.timer = setTimeout(() => {
        this.isLoading = true;
        axios
          .post(url, requestData)
            .then(
              (response: any) => {
                if (response.data.length !== 0) {
                  this.options = response.data.map((simNumber: any) => {
                    return {
                      tmlNumber: simNumber.number,
                      simNumber: simNumber.iccid,
                      expiryDate: simNumber.expiryDate,
                    };
                  });
                }
              },
            ).finally(() => {
            this.isLoading = false;

            const inputInOptions = this.options.find((item: any) => item.simNumber === query);

            if (
              query.length === 19
              && inputInOptions === undefined
            ) {
              this.sendSimNumberSelectedEvent(query, false);
            }
          },
        );
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.multiselect-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 20px;

  :deep(.multiselect__option--highlight) {
    background: var(--color-primary, $color-primary);
  }

  :deep(.multiselect--disabled) {
    border-radius: 8px;
  }

  :deep(.multiselect--disabled .multiselect__select) {
      height: 41px;
  }
}
</style>
